<template>
  <v-container
    v-resize="calculateMarketFeaturesHeight"
    fluid
    :style="{ maxWidth: '1240px' }"
  >
    <div v-if="currentSubscription">
      <v-flex xs12 lg12 md12 class="pt-3" style="margin-bottom: 40px;">
        <v-card class="no-border">
          <h1 class="headline">Current subscription</h1>
          <h2 class="current-subscription">{{ currentSubscription }}</h2>
        </v-card>
      </v-flex>
    </div>

    <v-container fluid grid-list-md fill-height>
      <v-layout row wrap>
        <v-flex class="title-card" xs12 sm12 md4 lg2>
          <v-card class="no-border">
            <v-list class="subscription-list">
              <v-list-tile v-if="$vuetify.breakpoint.mdAndUp">
                <v-list-tile-title>
                  <v-flex
                    class="title text-xs-center font-weight-black"
                  ></v-flex>
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-title>
                  <v-flex
                    class="title text-xs-center font-weight-black"
                  ></v-flex>
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile avatar class="no-padding">
                <v-list-tile-content class="text-xs-left mb-33">
                  <v-flex>
                    Auto technical analysis by market analyzer
                  </v-flex>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile
                :class="{
                  'levels-list':
                    !collapseAccountValue && $vuetify.breakpoint.mdAndUp
                }"
                class="no-padding"
              >
                <v-list-tile-content class="text-xs-left mb-33">
                  <v-flex>
                    Max account value per exchange (USD)
                  </v-flex>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile
                :class="{
                  'levels-list':
                    !collapseSelectedMarkets && $vuetify.breakpoint.mdAndUp
                }"
                class="no-padding"
              >
                <v-list-tile-content class="text-xs-left mb-33">
                  <v-flex>
                    Max selected markets across exchanges
                  </v-flex>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile
                ref="marketFeatures"
                :class="{
                  'feature-list':
                    !collapseMarketFeatures && $vuetify.breakpoint.mdAndUp
                }"
                :style="
                  !collapseMarketFeatures && $vuetify.breakpoint.mdAndUp
                    ? 'height: ' + marketFeatureHeight
                    : ''
                "
                class="no-padding"
              >
                <v-list-tile-content class="text-xs-left mb-33 ">
                  <v-flex>
                    Available features
                  </v-flex>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile class="no-padding">
                <v-list-tile-content class="text-xs-left mb-33">
                  <v-flex>Customer support</v-flex>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile class="no-padding">
                <v-list-tile-content class="text-xs-left mb-33">
                  <v-flex>GSMG commission in % of trade profits</v-flex>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile
                v-if="currentSubscription"
                style="height: 135px"
                class="no-padding"
              >
                <v-list-tile-content class="text-xs-left mb-59">
                  <v-flex>30 day fee in USD</v-flex>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile v-else style="height: 83px" class="no-padding">
                <v-list-tile-content class="text-xs-left mb-59">
                  <v-flex>30 day fee in USD</v-flex>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
        <v-flex
          v-for="subscription in filteredSubscriptions"
          :key="subscription.name"
          xs12
          sm12
          md4
          lg2
        >
          <v-card class="new-border">
            <v-flex>
              <v-list class="subscription-list">
                <v-list-tile>
                  <v-list-tile-title>
                    <v-flex
                      class="title text-xs-center font-weight-black description-name"
                      >{{ subscription.name }}</v-flex
                    >
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile>
                  <v-select
                    v-if="subscription.levels && subscription.levels.length > 1"
                    v-model="subscription.selected"
                    :items="subscription.levels"
                    item-text="level"
                    height="32"
                    solo
                    hide-details
                    outline
                    dense
                    return-object
                  />
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content class="text-xs-center">
                    <v-flex class="responsive-title">
                      Auto technical analysis by market analyzer
                    </v-flex>
                    <v-flex style="width: 100%">
                      <v-icon style="color: #639BFB;">check_circle</v-icon>
                    </v-flex>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile :class="{ 'levels-list': !collapseAccountValue }">
                  <v-list-tile-content class="text-xs-center">
                    <v-flex class="responsive-title">
                      Max account value per exchange (USD)
                    </v-flex>
                    <v-flex
                      v-if="
                        subscription.levels && subscription.levels.length > 1
                      "
                      style="width: 100%"
                    >
                      <table
                        v-if="
                          !collapseAccountValue || !$vuetify.breakpoint.mdAndUp
                        "
                        class="levels mt-38 table-level-width"
                      >
                        <tr
                          v-for="level in subscription.levels"
                          :key="level.name"
                          :class="{
                            'selected-level':
                              subscription.selected.name === level.name
                          }"
                        >
                          <td class="align-right mr-1 levels-right">
                            {{ level.level }}
                          </td>
                          <td class="align-left ml-1 levels-left">
                            {{
                              formatNumber(
                                level.max_account_value_per_exchange_usd
                              )
                            }}
                          </td>
                        </tr>
                      </table>

                      <table v-else class="mt-38 table-level-width">
                        <tr class="selected-level">
                          <td class="align-center">
                            {{
                              formatNumber(
                                subscription.selected
                                  .max_account_value_per_exchange_usd
                              )
                            }}
                          </td>
                        </tr>
                      </table>
                    </v-flex>
                    <div v-else style="width: 100%">
                      <div
                        v-if="
                          subscription.selected
                            .max_account_value_per_exchange_usd
                        "
                      >
                        {{
                          formatNumber(
                            subscription.selected
                              .max_account_value_per_exchange_usd
                          )
                        }}
                        USD
                      </div>
                      <div v-else class="mt-45">
                        <span class="dark-blue-color">Unlimited</span>
                      </div>
                    </div>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile
                  :class="{ 'levels-list': !collapseSelectedMarkets }"
                >
                  <v-list-tile-content class="text-xs-center">
                    <v-flex class="responsive-title">
                      Max selected markets across exchanges
                    </v-flex>
                    <v-flex
                      v-if="
                        subscription.levels && subscription.levels.length > 1
                      "
                      style="width: 100%"
                    >
                      <table
                        v-if="
                          !collapseSelectedMarkets ||
                            !$vuetify.breakpoint.mdAndUp
                        "
                        class="levels table-level-width mt-55"
                      >
                        <tr
                          v-for="level in subscription.levels"
                          :key="level.name"
                          :class="{
                            'selected-level':
                              subscription.selected.name === level.name
                          }"
                        >
                          <td class="align-center">
                            {{ level.max_markets_across_exchanges }}
                          </td>
                        </tr>
                      </table>

                      <table v-else class="levels mt-55 table-level-width">
                        <tr class="selected-level">
                          <td class="align-center">
                            {{
                              subscription.selected.max_markets_across_exchanges
                            }}
                          </td>
                        </tr>
                      </table>
                    </v-flex>
                    <div v-else style="width: 100%" class="mt-70">
                      <div
                        v-if="
                          subscription.selected.max_markets_across_exchanges
                        "
                      >
                        <span class="dark-blue-color">{{
                          subscription.selected.max_markets_across_exchanges
                        }}</span>
                      </div>
                      <div v-else>Unlimited</div>
                    </div>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile
                  :class="{
                    'feature-list':
                      !collapseMarketFeatures && $vuetify.breakpoint.mdAndUp
                  }"
                  :style="
                    !collapseMarketFeatures && $vuetify.breakpoint.mdAndUp
                      ? 'height: ' + marketFeatureHeight
                      : ''
                  "
                >
                  <v-list-tile-content style="width: 100%" class="mt-45">
                    <v-flex class="responsive-title">
                      Market features
                    </v-flex>
                    <v-flex
                      v-if="
                        !collapseMarketFeatures || !$vuetify.breakpoint.mdAndUp
                      "
                      style="width: 100%"
                    >
                      <ul ref="marketFeatures">
                        <li
                          v-for="feature in subscription.marketFeatures"
                          style="color: #103A84;"
                        >
                          {{ feature }}
                        </li>
                      </ul>
                    </v-flex>
                    <div
                      v-else-if="
                        marketFeatures.length !==
                          subscription.marketFeatures.length
                      "
                      class="feature-numbers"
                    >
                      {{ subscription.marketFeatures.length }} /
                      {{ marketFeatures.length }}
                    </div>
                    <div v-else class="feature-numbers">
                      All
                    </div>
                  </v-list-tile-content>
                  <v-list-tile-action
                    v-if="$vuetify.breakpoint.mdAndUp"
                    class="collapse mt-45"
                  >
                    <v-btn icon @click="toggleMarketFeatures()"
                      ><v-icon>{{
                        !collapseMarketFeatures ? "expand_less" : "expand_more"
                      }}</v-icon></v-btn
                    >
                  </v-list-tile-action>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content class="text-xs-center">
                    <v-flex class="responsive-title">
                      Customer support
                    </v-flex>
                    <v-flex style="width: 100%" class="mt-35">
                      <div
                        v-if="
                          subscription.name === 'Standard' ||
                            subscription.name === 'Herring' ||
                            subscription.name === 'Dolphin'
                        "
                        class="dark-blue-color"
                        style="font-size: 18px;"
                      >
                        Standard
                      </div>
                      <div
                        v-if="
                          subscription.name === 'Shark' ||
                            subscription.name === 'Whale'
                        "
                        class="vertical-align font-weight-black title dark-blue-color"
                        style="padding-top: 5px;"
                      >
                        Priority
                      </div>
                    </v-flex>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content class="text-xs-center">
                    <v-flex class="responsive-title">
                      GSMG commission in %
                    </v-flex>
                    <v-flex style="width: 100%" class="mt-44 gsmg-percent">
                      {{
                        subscription.selected.gsmg_fee_pct_per_trade
                          ? subscription.selected.gsmg_fee_pct_per_trade
                          : "-"
                      }}
                    </v-flex>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile class="fee-tile mt-34">
                  <v-list-tile-content class="text-xs-center">
                    <v-flex class="responsive-title">
                      30 day fee in USD
                    </v-flex>
                    <v-flex style="width: 100%">
                      <div v-if="subscription.selected.sub_fee_usd_per_30_days">
                        <div class="display-1 font-weight-black">
                          $ {{ subscription.selected.sub_fee_usd_per_30_days }}
                        </div>
                        <div class="body-1">To be paid in ETH or BNB</div>
                      </div>
                      <strong
                        v-else-if="subscription.name === 'Standard'"
                        class="standard-percent"
                      >
                        0.0625% <sup>*</sup>
                      </strong>
                      <div v-else class="display-1 font-weight-black">-</div>
                    </v-flex>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-flex>
            <v-card-actions v-if="currentSubscription">
              <v-btn
                style="width: 100%"
                class="text-xs-center subscribe-btn"
                :disabled="currentSubscription === subscription.selected.name"
                color="primary"
                @click="
                  $emit('change-subscription', subscription.selected.name)
                "
              >
                {{
                  currentSubscription === subscription.selected.name
                    ? "Current"
                    : "Subscribe"
                }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex
          v-if="$route.name != 'subscriptions'"
          xs12
          lg12
          md12
          offset-md2
          class="pt-3"
        >
          <v-card class="no-border standard-desc">
            <sup>*</sup>0.0625% of the managed value (but no less than 5 USD
            unless exceeded by the GSMG trade commissions)
          </v-card>
        </v-flex>
        <v-flex
          v-if="$route.name == 'subscriptions'"
          xs12
          lg4
          md4
          offset-md2
          class="pt-3"
        >
          <v-card class="no-border standard-desc">
            <sup>*</sup>0.0625% of the managed value but no less than 5 USD
            unless exceeded by the GSMG trade commissions
          </v-card>
        </v-flex>
        <v-flex
          v-if="$route.name == 'subscriptions'"
          xs12
          lg5
          md4
          class="pt-3 text-xs-center hide"
        >
          <v-card class="no-border">
            <img :src="'/img/most_popular.svg'" alt="Best choice" />
          </v-card>
        </v-flex>

        <v-flex xs12 lg12 md12 class="pt-3">
          <v-card class="no-border">
            <v-card-title>
              <div class="looking-title">
                Looking for an enterprise package?
              </div>
            </v-card-title>
            <v-card-text v-if="currentSubscription" class="pt-1 mb-5">
              <span class="looking-description">
                Tailored subscriptions negotiable. Contact us at
                <a href="mailto:enterprise@gsmg.io">enterprise@gsmg.io</a>
              </span>
            </v-card-text>
            <v-card-text v-else class="pt-1 mb-5">
              <span class="looking-description">
                Contact us for more! Tailored subscriptions negotiable.
              </span>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "Subscriptions",
  props: {
    currentSubscription: String
  },
  data: () => ({
    subscriptions: {},
    filteredSubscriptions: [],
    collapseAccountValue: true,
    collapseSelectedMarkets: true,
    collapseMarketFeatures: true,
    marketFeatures: [],
    marketFeatureHeight: 0
  }),
  computed: {
    subscriptionsArray() {
      return Object.values(this.subscriptions);
    }
  },
  watch: {
    subscriptionsArray() {
      const result = [];

      if (!this.subscriptionsArray.length) {
        this.filteredSubscriptions = [];
      }

      const subscriptions = [
        "Standard",
        "Herring",
        "Dolphin",
        "Shark",
        "Whale"
      ];

      for (const subscription of subscriptions) {
        const levels = this.getSubscriptionsByName(subscription).map(level => ({
          ...level,
          level: level.name.replace(subscription, "").trim()
        }));
        const formattedSubscription = {
          name: subscription,
          levels: levels,
          selected: levels[0],
          marketFeatures: levels[0].market_features.map(feature => {
            let suffix = "";

            if (feature.market_feature_name === "Trade aggressiveness") {
              if (subscription === "Herring") {
                suffix = " (low risk only / 15%)";
              }
              if (subscription === "Dolphin") {
                suffix = " (low to medium risk only / 50%)";
              }
            }

            return feature.market_feature_name + suffix;
          })
        };

        result.push(formattedSubscription);
      }

      this.filteredSubscriptions = result;
    }
  },
  created: async function() {
    await axios.get("/api/v1/subscriptions").then(res => {
      this.subscriptions = res.data;
      this.$nextTick(this.calculateMarketFeaturesHeight);
    });

    await axios.get("/api/v1/subscriptions/market-features").then(res => {
      this.marketFeatures = res.data;
    });
  },
  mounted() {
    this.calculateMarketFeaturesHeight();
  },
  methods: {
    formatNumber(value) {
      return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    async toggleMarketFeatures() {
      this.collapseMarketFeatures = !this.collapseMarketFeatures;
      await this.$nextTick();
      this.calculateMarketFeaturesHeight();
    },

    calculateMarketFeaturesHeight() {
      let maxHeight = 0;
      if (Array.isArray(this.$refs.marketFeatures)) {
        console.log(this.$refs.marketFeatures);
        for (const list of this.$refs.marketFeatures) {
          const height = Number.parseInt(
            getComputedStyle(list).height.replace("px", "")
          );
          if (height > maxHeight) {
            maxHeight = height;
          }
        }
      } else {
        maxHeight = Number.parseInt(
          getComputedStyle(this.$refs.marketFeatures.$el).height.replace(
            "px",
            ""
          )
        );
      }

      this.marketFeatureHeight = maxHeight + 20 + "px";
    },
    getSubscriptionsByName(name) {
      return this.subscriptionsArray.filter(s => s.name.startsWith(name));
    }
  }
};
</script>

<style scoped>
.responsive-title {
  width: 100%;
  display: none;
  font-weight: bold;
  text-align: center;
  margin-top: 10px;
}

>>> .fee-tile {
  height: 75px;
}

>>> .fee-tile .v-list-tile-content {
  height: 75px;
}

>>> .subscription-list .v-list__tile {
  height: max-content;
  min-height: 56px;
}

>>> .subscription-list {
  background: inherit;
  color: rgba(16, 58, 132, 0.7);
}

>>> .v-select__selections {
  padding-top: 0 !important;
  color: rgba(16, 58, 132, 0.7) !important;
  margin-left: 12px;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
}

>>> .v-input__slot {
  min-height: 32px !important;
  border: 1px solid rgba(16, 58, 132, 0.7) !important;
  box-sizing: border-box !important;
  border-radius: 30px !important;
  width: 128px !important;
}

>>> .v-input__control {
  align-content: center;
}
.levels-list >>> .v-list__tile {
  height: 140px;
}

.feature-list >>> .v-list__tile {
  height: 105%;
}

>>> .v-list__tile__title {
  height: 30px !important;
  line-height: 30px !important;
  font-size: 16px;
}
@media (max-width: 960px) {
  .levels-list >>> .v-list__tile,
  .feature-list >>> .v-list__tile {
    height: max-content;
  }

  >>> .v-list__tile {
    height: max-content;
  }

  .responsive-title {
    display: block;
  }

  .title-card {
    display: none;
  }

  >>> .fee-tile {
    height: max-content;
  }

  >>> .fee-tile .v-list-tile-content {
    height: max-content;
  }

  .hide {
    display: none;
  }
}

tr.selected-level td {
  color: #103a84 !important;
}

table {
  width: 100%;
}
table {
  height: 100%;
}

.table-level-width {
  margin-left: auto;
  margin-right: auto;
}

.align-right {
  text-align: right;
}
.levels-left {
  width: 50%;
  padding-left: 5px;
}

.levels-right {
  width: 50%;
  padding-right: 5px;
}

.align-left {
  text-align: left;
}

.collapse {
  width: 36px;
  min-width: 0;
}

.no-border {
  box-shadow: none;
  background-color: inherit;
  border-color: inherit;
}
.new-border {
  background: linear-gradient(180deg, #ffffff 0%, #f2f7ff 100%);
  box-shadow: 4px 6px 20px rgba(57, 95, 169, 0.18);
  border-radius: 5px;
}

.display-1 {
  font-family: "Lato", serif !important;
  font-style: normal;
  line-height: 140%;
  text-align: center;
  color: #103a84;
}
.description-name {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold !important;
  font-size: 22px !important;
  line-height: 26px;
  color: #103a84;
}

.looking-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: 900;
  font-size: 34px;
  line-height: 41px;
  color: #103a84;
  letter-spacing: 0.02em;
  margin-top: 104px;
}

.looking-description {
  font-family: "Lato", serif !important;
  font-style: italic;
  font-weight: normal;
  font-size: 18px;
  line-height: 140%;
  color: #103a84;
}

.dark-blue-color {
  color: #103a84 !important;
}

.standard-desc {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 140%;
  color: rgba(16, 58, 132, 0.6);
}

.headline {
  font-family: "Lato", serif !important;
  font-style: italic;
  font-weight: normal;
  font-size: 18px;
  line-height: 140%;
  color: #103a84;
  padding-left: 24px;
}
.current-subscription {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 34px;
  line-height: 41px;
  color: #103a84;
  padding-left: 24px;
  margin-top: 8px;
}
.subscribe-btn {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff;
  background: linear-gradient(180deg, #468aff 0%, #0051dd 100%);
  border-radius: 70px;
  box-shadow: none !important;
}
.no-padding >>> .v-list__tile {
  padding: 0px;
}
.feature-numbers {
  text-align: center;
  font-weight: bold;
  width: 100%;
  font-size: 18px;
  color: #103a84;
}

.standard-percent {
  font-size: 18px;
  color: #103a84;
}

.gsmg-percent {
  color: #103a84;
}
>>>.theme--light .v-list__tile__title {
  color: #8691a4;
}
.theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
  background: #ffffff !important;
}
>>> .theme--light.v-list.v-list--dense .primary--text .v-list__tile__title {
  color: #103a84;
}
>>> .theme--light.v-list.v-list--dense .primary--text {
  background: #f5f5f5;
}
.theme--light >>> .v-input__slot {
  box-shadow: none !important;
}
>>> .theme--dark.v-list.v-list--dense .primary--text .v-list__tile__title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  color: #e9e9e9;
}
>>>.theme--dark.v-icon.primary--text {
  color: #fff !important;
}
>>> .theme--dark.v-list.v-list--dense .primary--text {
  background: rgba(255, 255, 255, 0.14);
}
.theme--dark {
  color: rgba(255, 255, 255, 0.5);
}
.theme--dark a {
  color: #ffffff;
}
.theme--dark .new-border {
  background: #212121;
}
.theme--dark .looking-title,
.theme--dark .looking-description,
.theme--dark .dark-blue-color,
.theme--dark tr.selected-level td,
.theme--dark .feature-numbers,
.theme--dark .display-1,
.theme--dark .standard-percent,
.theme--dark .headline,
.theme--dark .current-subscription,
.theme--dark ul li,
.theme--dark >>> .v-btn__content,
.theme--dark .gsmg-percent,
.theme--dark .description-name {
  color: #ffffff !important;
}
.theme--dark .looking-description a {
  color: #639bfb;
}
.theme--dark >>> .v-select__selection,
.theme--dark >>> .vv-list__tile__content {
  color: #ffffff;
}
.theme--dark.new-border {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.theme--dark >>> .v-input__slot {
  border: 1px solid #ffffff !important;
}
.mb-33 {
  margin-bottom: 33px;
}

.mt-45 {
  margin-top: 45px;
}
.mt-28 {
  margin-top: 28px;
}
.mt-34 {
  margin-top: 34px;
}
.mt-35 {
  margin-top: 35px;
}
.mt-36 {
  margin-top: 36px;
}
.mt-38 {
  margin-top: 38px;
}
.mt-44 {
  margin-top: 44px;
}
.mt-45 {
  margin-top: 45px;
}
.mt-55 {
  margin-top: 55px;
}
.mt-59 {
  margin-top: 59px;
}
.mt-65 {
  margin-top: 65px;
}
.mt-70 {
  margin-top: 70px;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/Subscriptions.vue